import useImage from "hooks/useImage";
import { API_HOST } from "config";

const ImageHelper = ({ img, alt, className, ...rest }) => {
    return (
        <div className={className}>
            <img src={img} alt={alt} {...rest} />
        </div>
    );
};

const EmptyImage = ({ text, className, ...rest }) => {
    if (!text) text = "This image is lost..";
    const imgSize = 10 * text.length;
    const altImage = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='${imgSize}' height='${imgSize}'%3E%3Crect width='${imgSize}' height='${imgSize}' fill='%23333'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' font-family='sans-serif' font-size='18' fill='%23999'%3E${text}%3C/text%3E%3C/svg%3E`;
    return (
        <ImageHelper
            img={altImage}
            alt={text}
            className={className}
            {...rest}
        />
    );
};

const LoadLocalImage = ({ fileName, alt, className, ...rest }) => {
    const { loading, error, image } = useImage(fileName);
    let altText = "";

    if (error) {
        altText = alt;
    } else if (loading) altText = "loading";
    else
        return (
            <ImageHelper
                img={image}
                alt={alt}
                className={className}
                {...rest}
            />
        );
    return <EmptyImage text={altText} className={className} {...rest} />;
};

const Image = ({ local, fileName, alt, className, ...rest }) => {
    if (!fileName) {
        return <EmptyImage text={alt} className={className} {...rest} />;
    }
    if (local)
        return (
            <LoadLocalImage
                fileName={fileName}
                alt={alt}
                className={className}
                {...rest}
            />
        );
    const url = API_HOST + fileName;
    return <ImageHelper img={url} alt={alt} className={className} {...rest} />;
};

export default Image;
